<div class="ph-page">
  <!-- NAV -->
  <nav aria-label="Main navigation">
    <a href="#"
      ><img src="assets/logos/SVG/Handle_Horz_Logo.svg" alt="Handle" class="app-logo-img"
    /></a>
    <ul class="nav-links">
      <li>
        <a data-testid="for-students" [routerLink]="['/home']" fragment="for-students"
          >For Students</a
        >
      </li>
      <li>
        <a data-testid="for-counselors" [routerLink]="['/home']" fragment="how">For Counselors</a>
      </li>
      <li><a data-testid="about" [routerLink]="['/home']" fragment="mission">About</a></li>
      <li><a data-testid="sign-in" routerLink="/login" class="nav-cta">Sign in</a></li>
    </ul>
  </nav>

  <!-- BANNER PHOTO -->
  <div class="hero-banner-photo">
    <img
      src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1400&auto=format&fit=crop&q=80"
      alt="Students collaborating at a table"
    />
    <div class="hero-banner-overlay" aria-hidden="true">
      <div class="hero-banner-text">
        <span>Handle's got you.</span>
      </div>
    </div>
  </div>

  <!-- HERO -->
  <section class="hero" aria-labelledby="hero-title">
    <div class="hero-bg" aria-hidden="true"></div>
    <div class="hero-orb hero-orb-1" aria-hidden="true"></div>
    <div class="hero-orb hero-orb-2" aria-hidden="true"></div>
    <div class="hero-orb hero-orb-3" aria-hidden="true"></div>

    <div class="hero-content">
      <div class="hero-eyebrow" aria-hidden="true">
        <div class="hero-eyebrow-dot" aria-hidden="true"></div>
        Built for every student
      </div>
      <h1 class="hero-title" id="hero-title">
        Don't just get by.
        <em>Get a Handle.</em>
      </h1>
      <p class="hero-sub">
        Every student deserves a counselor in their corner. Handle makes that possible — no matter
        how many students are on the list.
      </p>
      <div class="hero-actions">
        <a
          data-testid="get-started"
          href="/getStarted"
          class="btn-primary"
          aria-label="Get started with Handle"
          >Let's get started →</a
        >
        <button
          data-testid="see-how-it-works"
          (click)="openScreenshots()"
          class="btn-outline"
          aria-label="See how Handle works"
        >
          See how it works
        </button>
      </div>
      <div class="hero-stats" role="list" aria-label="Key statistics">
        <div
          class="hero-stat"
          role="listitem"
          aria-label="408 to 1 — students per counselor on average"
        >
          <div class="hero-stat-num" aria-hidden="true">408:1</div>
          <div class="hero-stat-label" aria-hidden="true">Students per counselor, on average</div>
        </div>
        <div class="hero-stat" role="listitem" aria-label="1 to 1 — what every student deserves">
          <div class="hero-stat-num" aria-hidden="true">1:1</div>
          <div class="hero-stat-label" aria-hidden="true">What every student deserves</div>
        </div>
        <div class="hero-stat" role="listitem" aria-label="Handle bridges that gap">
          <div class="hero-stat-num" aria-hidden="true">Handle</div>
          <div class="hero-stat-label" aria-hidden="true">Bridges that gap</div>
        </div>
      </div>
    </div>

    <!-- Card stack — decorative UI preview -->
    <div class="hero-visual" aria-hidden="true">
      <div class="hero-card-stack">
        <div class="hero-card hero-card-main">
          <div class="card-avatar-row">
            <div class="card-avatar">AK</div>
            <div>
              <div class="card-name">Anna Kolb</div>
              <div class="card-role">Future Software Engineer · 11th Grade</div>
            </div>
          </div>
          <div class="card-progress-label">
            <span>Profile strength</span>
            <span class="card-pct">72%</span>
          </div>
          <div class="card-progress-bar">
            <div class="card-progress-fill" style="width: 72%"></div>
          </div>
          <div class="card-tags">
            <span class="tag tag-coral">Coding</span>
            <span class="tag tag-navy">Math</span>
            <span class="tag tag-green">Leadership</span>
          </div>
        </div>
        <div class="hero-card hero-card-accent">
          <div class="card-accent-label">From your counselor</div>
          <div class="card-accent-value" style="font-size: 13px; margin-top: 4px; line-height: 1.5">
            📋 SAT registration closes Apr 4 — don't miss it!
          </div>
          <div style="margin-top: 8px; font-size: 11px; opacity: 0.7">
            Sent to all 11th graders · Mr. Rivera
          </div>
        </div>
        <div class="hero-card hero-card-bottom">
          <div class="card-mentors-label">Upcoming for you</div>
          <div style="display: flex; flex-direction: column; gap: 6px; margin-top: 6px">
            <div style="font-size: 12px; color: #1a3c5e; font-weight: 500">
              🗓 Spring Internship Fair · Apr 14
            </div>
            <div style="font-size: 12px; color: #4a6580">Gym · 20+ local employers</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- MISSION -->
  <section class="mission" id="mission" aria-labelledby="mission-title">
    <div class="mission-inner">
      <div class="mission-text">
        <div class="section-eyebrow" aria-hidden="true">Handle the gap</div>
        <h2 class="section-title" id="mission-title">One counselor. Hundreds of students.</h2>
        <p class="section-sub">
          In schools across the country — especially under-resourced ones — guidance counselors are
          stretched thin. Most students never get a real conversation. Handle was built so no one
          falls through the cracks.
        </p>
        <p class="section-sub" style="margin-top: 14px">
          Counselors use Handle to reach every student with the right information at the right time.
          Students always know someone's looking out for them.
        </p>
      </div>
      <div class="mission-cards" role="list" aria-label="The problem and solution">
        <div
          class="mission-card mission-card-problem"
          role="listitem"
          aria-label="408 students per counselor — national average"
        >
          <div class="mission-card-num" aria-hidden="true">408</div>
          <div class="mission-card-label" aria-hidden="true">
            students per counselor<br />national average
          </div>
        </div>
        <div
          class="mission-card mission-card-solution"
          role="listitem"
          aria-label="Handle keeps counselors connected to every single student"
        >
          <div class="mission-card-num" aria-hidden="true">✓</div>
          <div class="mission-card-label" aria-hidden="true">
            Handle keeps counselors<br />connected to every single one
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- HOW IT WORKS -->
  <section class="how" id="how" aria-labelledby="how-title">
    <div class="how-header">
      <div class="section-eyebrow" aria-hidden="true">How it works</div>
      <h2 class="section-title" id="how-title">Simple for students. Powerful for counselors.</h2>
    </div>
    <ol class="how-steps" aria-label="How Handle works">
      <li class="how-step">
        <div class="how-step-num how-step-coral" aria-hidden="true">1</div>
        <div class="how-step-title">Build your profile</div>
        <div class="how-step-desc">
          Students set up a profile with their interests, goals, and grade — plus a custom career
          avatar.
        </div>
      </li>
      <li class="how-step">
        <div class="how-step-num how-step-teal" aria-hidden="true">2</div>
        <div class="how-step-title">Counselors reach out</div>
        <div class="how-step-desc">
          Send targeted announcements, reminders, and opportunities to exactly the students who need
          them.
        </div>
      </li>
      <li class="how-step">
        <div class="how-step-num how-step-green" aria-hidden="true">3</div>
        <div class="how-step-title">Students stay informed</div>
        <div class="how-step-desc">
          SAT dates, internship fairs, scholarship windows — it all shows up where students already
          are.
        </div>
      </li>
      <li class="how-step">
        <div class="how-step-num how-step-navy" aria-hidden="true">4</div>
        <div class="how-step-title">Connect directly</div>
        <div class="how-step-desc">
          Students and counselors can message each other — no email chains, no missed notes.
        </div>
      </li>
    </ol>
  </section>

  <!-- FOR STUDENTS -->
  <section class="for-students" id="for-students" aria-labelledby="students-title">
    <div class="section-eyebrow" aria-hidden="true">For students</div>
    <h2 class="section-title" id="students-title">Your profile. Your story. Your future.</h2>
    <p class="section-sub">
      Handle isn't just another school tool. It's your space — your career identity, your goals,
      your connection to the people who can actually help you get there.
    </p>
    <div
      class="features-grid"
      style="margin-top: 44px"
      role="list"
      aria-label="Features for students"
    >
      <div class="feature-card" role="listitem">
        <div class="feature-icon feature-icon-coral" aria-hidden="true">🎭</div>
        <div class="feature-title">Your career avatar</div>
        <div class="feature-desc">
          See yourself as the future attorney, engineer, or chef you want to be. Build a career
          avatar in your future attire and own that identity from day one.
        </div>
      </div>
      <div class="feature-card" role="listitem">
        <div class="feature-icon feature-icon-green" aria-hidden="true">👤</div>
        <div class="feature-title">Your LinkedIn — starting now</div>
        <div class="feature-desc">
          Build a profile with your interests, goals, and story. Let your counselor see the real you
          — before you ever walk through their door.
        </div>
      </div>
      <div class="feature-card" role="listitem">
        <div class="feature-icon feature-icon-teal" aria-hidden="true">📅</div>
        <div class="feature-title">Never miss a deadline</div>
        <div class="feature-desc">
          SAT registrations. Scholarship windows. Internship fairs near you. Handle keeps it all in
          one place so nothing slips by.
        </div>
      </div>
    </div>
  </section>

  <!-- TESTIMONIALS -->
  <section class="testimonials" aria-labelledby="testimonials-title">
    <div class="section-eyebrow" aria-hidden="true">Real stories</div>
    <h2 class="section-title" id="testimonials-title">Handle's got them too.</h2>
    <div class="testimonials-grid" role="list" aria-label="Student and counselor testimonials">
      <div class="testimonial-card" role="listitem">
        <p class="testimonial-quote">
          "My counselor has 400 students. I never thought I'd actually hear from her. Handle changed
          that — she messaged me directly about a program I didn't even know existed."
        </p>
        <div class="testimonial-author">
          <div class="testimonial-avatar" style="background: #d4845a" aria-hidden="true">JL</div>
          <div>
            <div class="testimonial-name">Jordan Lee</div>
            <div class="testimonial-role">11th Grade · Lincoln High</div>
          </div>
        </div>
      </div>
      <div class="testimonial-card" role="listitem">
        <p class="testimonial-quote">
          "I used to feel like just another face in the hallway. Handle made me feel like someone
          actually knew my name and what I was trying to do with my life."
        </p>
        <div class="testimonial-author">
          <div class="testimonial-avatar" style="background: #2ecc71" aria-hidden="true">MR</div>
          <div>
            <div class="testimonial-name">Maya Rodriguez</div>
            <div class="testimonial-role">12th Grade · Westview Academy</div>
          </div>
        </div>
      </div>
      <div class="testimonial-card" role="listitem">
        <p class="testimonial-quote">
          "I can finally reach ALL my students — not just the ones who walk through my door. Handle
          is what I've needed for years."
        </p>
        <div class="testimonial-author">
          <div class="testimonial-avatar" style="background: #1a7a6e" aria-hidden="true">MR</div>
          <div>
            <div class="testimonial-name">Mr. Rivera</div>
            <div class="testimonial-role">School Counselor · 9 years</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="cta-banner" aria-labelledby="cta-title">
    <h2 class="section-title" id="cta-title">Get a Handle on <em>your future.</em></h2>
    <p class="section-sub">
      Join students and counselors who are closing the gap — one profile at a time.
    </p>
    <a
      data-testid="get-started2"
      href="/getStarted"
      class="btn-white"
      aria-label="Get started with Handle"
      >Let's get started →</a
    >
  </section>

  <!-- FOOTER -->
  <footer class="ph-footer" aria-label="Site footer">
    <div class="footer-top">
      <div>
        <a href="#"
          ><img src="assets/logos/SVG/Handle_Vert_Logo.svg" alt="Handle" class="app-logo-img"
        /></a>
        <p class="footer-tagline">
          Connecting students and counselors — one profile at a time.<br />
          Built for schools where every student deserves to be seen.
        </p>
      </div>
      <nav aria-label="Platform links">
        <div class="footer-col-title" aria-hidden="true">Platform</div>
        <ul class="footer-links">
          <li><a href="#">For Students</a></li>
          <li><a href="#">For Counselors</a></li>
          <li><a href="#">Features</a></li>
          <li><a href="#">Pricing</a></li>
        </ul>
      </nav>
      <nav aria-label="Company links">
        <div class="footer-col-title" aria-hidden="true">Company</div>
        <ul class="footer-links">
          <li><a href="#">About</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Careers</a></li>
          <li><a href="#">Contact</a></li>
        </ul>
      </nav>
      <nav aria-label="Legal links">
        <div class="footer-col-title" aria-hidden="true">Legal</div>
        <ul class="footer-links">
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Terms of Use</a></li>
          <li><a href="#">COPPA Notice</a></li>
        </ul>
      </nav>
    </div>
    <div class="footer-bottom">
      <span>© 2026 Handle. All rights reserved.</span>
      <span aria-label="Made for students, with love">Made for students, with ♥</span>
    </div>
  </footer>
</div>
